import { useEffect, useState } from 'react';
import Header from 'src/components/demo-day/header/Header';
import cx from '../demo-day/index.module.scss';
import styles from '../demo-day-register/index.module.scss';
import Stepper from 'src/components/demo-day-register/Stepper/Stepper';
import { Loader, TStep } from 'src/components/common';
import { clearDemoDay, getDemoDay } from 'src/store/venture/venture.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useUrlParamValue } from 'src/hooks';
import Calendar from 'src/components/demo-day-register/calendar/Calendar';
import { useNavigate } from 'react-router-dom';
import { lightbulbicon } from 'src/assets/images';
const DemoDaySlotBooking = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false)
    const { demoDay } = useAppSelector(
        (store) => store.venture
    );
    const { paramValue } = useUrlParamValue();

    const ventureVerseId: string = paramValue({ paramName: 'id' }) as string;
    const steps: TStep[] = [
        { label: 'Register' },
        { label: 'Pitch Deck' },
        { label: 'Book A Slot' }
    ];
    useEffect(() => {
        if (ventureVerseId) {
            setLoading(true)
            dispatch(getDemoDay({ ventureVerseId })).finally(() => setLoading(false))
        } else {
            navigate('/demo-day')
        }
        return () => {
            dispatch(clearDemoDay())
        }
    }, [ventureVerseId]);
    console.log(loading, 'loadingdata', demoDay);
    
    return (
        <div className={cx.demoDay}>
            <Header />
            <div className={cx.demoDayContent} style={{ paddingTop: 0 }}>
                <section className={styles.content}>
                    {!loading && demoDay && (
                        <div className={styles.container}>
                            <img src={lightbulbicon} alt="logo" className={styles.logo} />
                            <div className={styles.calendarContainer}>
                                <div>
                                    <div className={styles.stepperContainer}>
                                        <Stepper
                                            currentStep={2}
                                            steps={steps}
                                        />
                                    </div>
                                    <Calendar />
                                </div>
                            </div>
                        </div>
                    )}
                    {loading && (
                        <div className="pt-5">
                            <Loader />
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
};

export default DemoDaySlotBooking;
